// removed by extract-text-webpack-plugin
module.exports = {"signUpPageWrap":"qempo_SignUpPage_signUpPageWrap-2ROA8oG","signUpWrap":"qempo_SignUpPage_signUpWrap-2ZIF3lv"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/auth/components/SignUp/SignUpPage.scss
// module id = 1231
// module chunks = 0